import { SET_RESPONSE, HIDE_RESPONSE } from "../types/actionResponseTypes";

export const setActionResponse = (prop:string, datares: any) => ({ type: SET_RESPONSE, payload: {prop, datares} });

export const hideActionResponse = () => ({ type: HIDE_RESPONSE });